import { PERMISSIONS } from './permissions'

// `labelKey` is an i18n key (see src/i18n/locales/*/translation.json). Consumers
// (NavTabs) render it with `t(labelKey)`. `to` and `permission` are unchanged and
// still drive routing in AppRoutes.jsx.
export const MANAGEMENT_TABS = [
  { labelKey: 'nav.tabs.settings', to: 'settings', permission: PERMISSIONS.GENERAL_SETTINGS },
  { labelKey: 'nav.tabs.workers', to: 'workers', permission: PERMISSIONS.WORKERS },
  { labelKey: 'nav.tabs.farmingBlock', to: 'farming-block', permission: PERMISSIONS.FARMING_BLOCK },
  { labelKey: 'nav.tabs.activities', to: 'activities', permission: PERMISSIONS.ACTIVITIES },
  { labelKey: 'nav.tabs.devices', to: 'devices', permission: PERMISSIONS.DEVICES },
  { labelKey: 'nav.tabs.workday', to: 'workday', permission: PERMISSIONS.WORKDAY },
  { labelKey: 'nav.tabs.dataEdit', to: 'data-edit', permission: PERMISSIONS.DATA_EDIT },
  { labelKey: 'nav.tabs.stickers', to: 'stickers', permission: PERMISSIONS.STICKERS },
  { labelKey: 'nav.tabs.users', to: 'users', permission: PERMISSIONS.USERS }
]

export const DASHBOARD_TABS = [
  { labelKey: 'nav.tabs.lastWorkingDaySummary', to: 'last-working-day-summary', permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY },
  { labelKey: 'nav.tabs.dailyPickSummary', to: 'daily-pick-summary', permission: PERMISSIONS.DAILY_PICK_SUMMARY },
  { labelKey: 'nav.tabs.dailyAgroSummary', to: 'daily-agro-summary', permission: PERMISSIONS.DAILY_AGRO_SUMMARY },
  { labelKey: 'nav.tabs.dailyPackingSummary', to: 'daily-packing-summary', permission: PERMISSIONS.DAILY_PACKING_SUMMARY },
  { labelKey: 'nav.tabs.dailyAttendanceSummary', to: 'daily-attendance-summary', permission: PERMISSIONS.DAILY_ATTENDANCE_SUMMARY },
  // { labelKey: 'nav.tabs.weeklyPickSummary', to: 'weekly-pick-summary', permission: PERMISSIONS.WEEKLY_PICK_SUMMARY },
  // { labelKey: 'nav.tabs.weeklyAgroSummary', to: 'weekly-agro-summary', permission: PERMISSIONS.WEEKLY_AGRO_SUMMARY },
  { labelKey: 'nav.tabs.leam', to: 'leam', permission: PERMISSIONS.LEAM }
]
